<p dir="rtl" class="text-center text-danger">השעה {{localTimeString}}</p>

 
